/**
 * Reads VITE_* env vars baked at build time.
 */
function required(value: string | undefined, name: string): string {
  if (!value || value.startsWith("https://REPLACE")) {
    console.warn(`[conatus/web] Missing or placeholder env var ${name}; calls to it will fail.`);
    return value ?? "";
  }
  return value;
}

function optionalBaseUrl(value: string | undefined): string {
  if (value === undefined || value === "") return "";
  return required(value, "VITE_API_BASE_URL");
}

const region = import.meta.env.VITE_COGNITO_REGION ?? "us-east-1";
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "";
const cognitoAuthority = userPoolId
  ? `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`
  : "";

/**
 * Public simulator API origin baked at build time. Empty means "not configured"
 * for production; in dev, empty is OK because Vite proxies `/test-support/*` to
 * the simulator (see vite.config.ts).
 */
function simulatorBaseUrl(): string {
  const raw = (import.meta.env.VITE_SIMULATOR_BASE_URL as string | undefined) ?? "";
  return raw.trim().replace(/\/$/, "");
}

export const config = {
  apiBaseUrl: optionalBaseUrl(import.meta.env.VITE_API_BASE_URL),
  simulatorBaseUrl: simulatorBaseUrl(),
  cognito: {
    region,
    domain: import.meta.env.VITE_COGNITO_DOMAIN ?? "",
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
    userPoolId,
    authority: cognitoAuthority,
    scope: "openid email profile",
  },
};

export function isAuthConfigured(): boolean {
  return !config.apiBaseUrl.startsWith("https://REPLACE");
}

export type Config = typeof config;

/** Use with simulator API client: full URL in prod builds, or dev + empty env → same-origin proxy. */
export function isSimulatorApiReachable(): boolean {
  if (config.simulatorBaseUrl) return true;
  return Boolean(import.meta.env.DEV);
}
